import React from 'react';

interface BrandTextProps {
  language: 'zh-CN' | 'en-US';
  /** 'header' = 深色背景文字, 'footer' = 白色文字 */
  variant?: 'header' | 'footer';
  /** 字号基线 */
  size?: number;
}

/**
 * 品牌文字 —— "AI" 渐变强调
 * 中文：AI速览局
 * 英文：Global AI Tools
 */
const BrandText: React.FC<BrandTextProps> = ({
  language,
  variant = 'header',
  size = 18,
}) => {
  const isFooter = variant === 'footer';
  const baseColor = isFooter ? 'rgba(255,255,255,0.92)' : '#2a2a2a';

  const aiStyle: React.CSSProperties = {
    fontWeight: 900,
    fontSize: size * 1.15,
    letterSpacing: '1px',
    background: 'linear-gradient(135deg, #667eea 0%, #00D2FF 40%, #764ba2 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    filter: isFooter ? 'brightness(1.3)' : undefined,
    display: 'inline',
  };

  const textStyle: React.CSSProperties = {
    fontWeight: 700,
    fontSize: size,
    color: baseColor,
    letterSpacing: language === 'zh-CN' ? '1px' : '-0.3px',
    fontFamily: language === 'en-US'
      ? "'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif"
      : "'PingFang SC', 'Microsoft YaHei', -apple-system, sans-serif",
    whiteSpace: 'nowrap' as const,
    display: 'inline-flex',
    alignItems: 'baseline',
    gap: language === 'zh-CN' ? 2 : 4,
    lineHeight: 1.3,
  };

  if (language === 'zh-CN') {
    return (
      <span style={textStyle}>
        <span style={aiStyle}>AI</span>
        <span>速览局</span>
      </span>
    );
  }

  return (
    <span style={textStyle}>
      <span style={{ fontWeight: 600 }}>Global</span>
      <span style={aiStyle}>AI</span>
      <span style={{ fontWeight: 600 }}>Tools</span>
    </span>
  );
};

export default BrandText;
